{
  "hero.title": "Olá, sou o <span class=\"name\">André</span>.",
  "hero.desc": "Vou publicar sobre <strong>engenharia de software</strong> aqui.<br />Notas, demos e experimentos sobre sistemas agradáveis de\n        manter, fáceis de entender e confiáveis em produção.",
  "labs.title": "Labs",
  "labs.desc": "Demos e experimentos.",
  "labs.todo.title": "Todo",
  "labs.todo.desc": "Local-first, criptografado de ponta a ponta. Derivação de chave WebAuthn PRF, CRDT Yjs, relay AES-GCM.",
  "labs.modulith.title": "Frontend Modulith",
  "labs.modulith.desc": "Um build, um deploy — fronteiras de módulo aplicadas em tempo de compilação. Sem microfrontends, sem federação em tempo de execução.",
  "labs.federation.title": "Module Federation",
  "labs.federation.desc": "A mesma demo, reconstruída como microfrontends implantados de forma independente — fronteiras de módulo aplicadas em tempo de execução em vez de tempo de compilação.",
  "labs.wanderlust.title": "Wanderlust",
  "labs.wanderlust.desc": "Um planejador de viagens nativo em Kubernetes — Angular, gRPC, orquestração saga, feature flags e observabilidade full-stack, implantado em um cluster real.",
  "contact.title": "Contato",
  "contact.desc": "Escreva sua mensagem. Deixe seu endereço de e-mail se quiser que eu responda.",
  "contact.field.email": "Seu e-mail",
  "contact.field.email.optional": "(opcional)",
  "contact.field.message": "Mensagem",
  "contact.submit": "Enviar mensagem",
  "not-found.back": "← Início",
  "contact.status.pending": "Enviando…",
  "contact.status.ok": "Mensagem enviada! Obrigado.",
  "contact.status.error.generic": "Algo deu errado. Tente novamente mais tarde.",
  "contact.status.error.validation": "Preencha os campos obrigatórios corretamente."
}
